// Debug: Check if required functions and variables are available
console.log('🔍 Debug: Checking required dependencies...');
console.log('🔍 fetchConfig available:', typeof fetchConfig !== 'undefined');
console.log('🔍 routes available:', typeof routes !== 'undefined', routes);
console.log('🔍 PUB_SUB_EVENTS available:', typeof PUB_SUB_EVENTS !== 'undefined', PUB_SUB_EVENTS);
console.log('🔍 publish function available:', typeof publish !== 'undefined');

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        console.log('🔧 ProductForm constructor called');

        this.form = this.querySelector('form');
        console.log('🔧 Form found:', !!this.form);
        
        if (!this.form) {
          console.error('❌ No form found in ProductForm element');
          return;
        }

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // Prioritize cart drawer if cart_type is set to "drawer", otherwise use cart notification
        const cartType = window.Shopify?.theme?.settings?.cart_type || 'notification';
        console.log('🔧 Cart type setting:', cartType);
        
        if (cartType === 'page') {
          this.cart = null;
        } else if (cartType === 'drawer') {
          this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        } else {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }
        
        console.log('🔧 Cart notification found:', !!document.querySelector('cart-notification'));
        console.log('🔧 Cart drawer found:', !!document.querySelector('cart-drawer'));
        console.log('🔧 Cart element found:', !!this.cart, this.cart?.tagName);
        console.log('🔧 Selected cart element type:', this.cart?.tagName);
        
        this.submitButton = this.querySelector('[type="submit"]');
        console.log('🔧 Submit button found:', !!this.submitButton);
        
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          console.log('🔧 Submit button text element found:', !!this.submitButtonText);
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        console.log('🔧 ProductForm initialization complete');
      }

      onSubmitHandler(evt) {
        console.log('🚀 onSubmitHandler triggered');
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          console.log('⚠️ Button already disabled, returning');
          return;
        }

        console.log('🔧 Starting form submission process');
        this.handleErrorMessage();

        console.log('🔧 Setting button to loading state');
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        const spinner = this.querySelector('.loading__spinner');
        console.log('🔧 Loading spinner found:', !!spinner);
        if (spinner) {
          spinner.classList.remove('hidden');
        } else {
          console.warn('⚠️ No loading spinner found');
        }

        console.log('🔧 Preparing fetch config');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        console.log('🔧 Creating FormData');
        const formData = new FormData(this.form);
        console.log('🔧 FormData created, entries:', Array.from(formData.entries()));
        
        if (this.cart) {
          console.log('🔧 Adding cart sections to form data');
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          console.log('🔧 Sections to render:', sections);
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          console.warn('⚠️ No cart element found');
        }
        
        config.body = formData;
        console.log('🔧 Fetch config prepared:', config);

        console.log('🔧 Starting fetch request to:', routes.cart_add_url);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log('🔧 Fetch response received:', response.status, response.statusText);
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((response) => {
            console.log('🔧 Response parsed:', response);
            
            if (response.status) {
              console.error('❌ Cart error response:', response);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) {
                console.log('🔧 No sold out message element found');
                return;
              }
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('🔧 No cart element, redirecting to cart page');
              window.location = window.routes.cart_url;
              return;
            }

            console.log('🔧 Cart update successful, publishing event');
            if (!this.error) {
              console.log('🔧 Publishing cart update event');
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              console.log('🔧 Quick add modal detected');
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    console.log('🔧 Rendering cart contents after modal close');
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log('🔧 Rendering cart contents directly');
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('❌ Fetch error:', e);
            console.error('❌ Error details:', {
              message: e.message,
              stack: e.stack,
              formData: Array.from(formData.entries()),
              config: config
            });
          })
          .finally(() => {
            console.log('🔧 Finally block executed');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              console.log('🔧 Removing aria-disabled from button');
              this.submitButton.removeAttribute('aria-disabled');
            } else {
              console.log('⚠️ Error occurred, keeping button disabled');
            }
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) {
              console.log('🔧 Hiding loading spinner');
              spinner.classList.add('hidden');
            }
            console.log('🔧 Form submission process complete');
          });
      }

      handleErrorMessage(errorMessage = false) {
        console.log('🔧 handleErrorMessage called with:', errorMessage);
        if (this.hideErrors) {
          console.log('🔧 Errors hidden, returning');
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        console.log('🔧 Error message wrapper found:', !!this.errorMessageWrapper);
        
        if (!this.errorMessageWrapper) {
          console.warn('⚠️ No error message wrapper found');
          return;
        }
        
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        console.log('🔧 Error message element found:', !!this.errorMessage);

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          console.log('🔧 Setting error message:', errorMessage);
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        console.log('🔧 toggleSubmitButton called:', disable, text);
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        const input = this.form.querySelector('[name=id]');
        console.log('🔧 Variant ID input found:', !!input, input?.value);
        return input;
      }
    }
  );
}
